
// Herko
export const environment = {
  production: true,
  Ambiente: 2,
  Id_Application: 5,
  appName: 'Conta-E',
  appVersion: '3.8.30',
  AppToken: 'F0BD2798-C8DD-4D0E-8B33-3C76A5ADB487',
  LoginURL: "https://apps.ximplify.mx/"
};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts